export const CALENDAR_ERROR_TYPE = {
	CREATE_FAILED: "CREATE_FAILED",
	UPDATE_FAILED: "UPDATE_FAILED",
} as const;

export type CalendarErrorType = (typeof CALENDAR_ERROR_TYPE)[keyof typeof CALENDAR_ERROR_TYPE];

export const VIDEO_CONFERENCING_ERROR_TYPE = {
	CREATE_FAILED: "CREATE_FAILED",
	UPDATE_FAILED: "UPDATE_FAILED",
	DELETE_FAILED: "DELETE_FAILED",
} as const;

export type VideoConferencingErrorType =
	(typeof VIDEO_CONFERENCING_ERROR_TYPE)[keyof typeof VIDEO_CONFERENCING_ERROR_TYPE];
